import { Card, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import CampaignSettingsPanel from './components/CampaignSettingsPanel';
import { useCampaigns } from './hooks/useCampaigns';

export default function CampaignDetailsPage(): JSX.Element {
  const theme = useTheme();
  const navigate = useNavigate();
  const { organizationId, campaignId } = useParams<{
    organizationId: string;
    campaignId: string;
  }>();

  const { campaigns, isLoading, refetch } = useCampaigns(organizationId || '');
  const campaign = campaigns?.find((c) => c.id === campaignId);

  const handleBack = (): void => {
    navigate(
      PATH_DASHBOARD.general.organizations.campaigns(organizationId || ''),
    );
  };

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flex: 1,
        boxShadow: theme.customShadows.z24,
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px', flex: 1 }}>
        <Stack
          sx={{ minHeight: '84px' }}
          direction="row"
          alignItems="center"
          p={3}
          spacing={1}
        >
          <IconButton onClick={handleBack} size="small">
            <Iconify icon="eva:arrow-back-fill" />
          </IconButton>
          <Stack spacing={0.25}>
            <Typography variant="h6">
              {isLoading ? '...' : campaign?.name ?? 'Kampania'}
            </Typography>
            {campaign?.description && (
              <Typography variant="body2" color="text.secondary">
                {campaign.description}
              </Typography>
            )}
          </Stack>
        </Stack>

        <Stack sx={{ flex: 1, height: 1, px: 3, pb: 3 }}>
          <CampaignSettingsPanel
            campaign={campaign}
            organizationId={organizationId || ''}
            onUpdated={refetch}
            onDeleted={handleBack}
          />
        </Stack>
      </Stack>
    </Card>
  );
}
